import jwtDecode from 'jwt-decode';

type Dimensions = {
  width: number;
  height: number;
};

type ImageWithDimensions = Dimensions & {
  url: string;
};
type DeepLinkWindow = Partial<Dimensions> & {
  targetName?: string;
  windowFeatures?: string;
};
type DeepLinkIFrame = Partial<Dimensions> & {
  src: string;
};
type PeriodicDateTime = {
  startDateTime?: string;
  endDateTime?: string;
};

type ContentTypeBaseProps = {
  title?: string;
  text?: string;
  icon?: string;
};

export type LinkContentType = ContentTypeBaseProps & {
  type: 'link';
  url: string;
  thumbnail?: ImageWithDimensions;
  embed?: {
    html: string;
  };
  window?: DeepLinkWindow;
  iframe?: DeepLinkIFrame;
};

export type LtiResourceLinkContentType = ContentTypeBaseProps & {
  type: 'ltiResourceLink';
  url: string;
  thumbnail?: ImageWithDimensions;
  window?: DeepLinkWindow;
  iframe?: Omit<DeepLinkIFrame, 'src'>;
  custom?: Record<string, string>;
  lineItem?: {
    scoreMaximum: number;
    label?: string;
    resourceId?: string;
    tag?: string;
    gradesReleased?: boolean;
  };
  available?: PeriodicDateTime;
  submission?: PeriodicDateTime;
};

export type FileContentType = ContentTypeBaseProps & {
  type: 'file';
  url: string;
  thumbnail?: ImageWithDimensions;
  expiresAt?: string;
};

export type HtmlContentType = Omit<ContentTypeBaseProps, 'icon'> & {
  type: 'html';
  html: string;
};

export type ImageContentType = ContentTypeBaseProps &
  Partial<Dimensions> & {
    type: 'image';
    url: string;
    thumbnail?: ImageWithDimensions;
  };

export type ContentItem =
  | LinkContentType
  | LtiResourceLinkContentType
  | FileContentType
  | HtmlContentType
  | ImageContentType;

export function extractLtiDeepLinkInfo(jwt: string) {
  const payload = jwtDecode<{
    'https://purl.imsglobal.org/spec/lti-dl/claim/content_items': LtiResourceLinkContentType[];
  }>(jwt);

  if (!payload['https://purl.imsglobal.org/spec/lti-dl/claim/content_items'].length) return undefined;

  return payload['https://purl.imsglobal.org/spec/lti-dl/claim/content_items'][0];
}
